import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
// import moment from "moment";
import DispatchContext from "../../contexts/DispatchContext";
import StateContext from "../../contexts/StateContext";
import DataFetcher from "../../utils/DataFetcher";
import LoadingIndicator from "../elements/LoadingIndicator";
import StateLights from "../elements/StateLights";
import FilterBar from "../elements/FilterBar";
import NoResults from "../elements/NoResults";
// import formdata from "../../data/formdata";
import { sortBy, dispError } from "../../utils/Tools";

function ListLicences(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();

  // const [licenceData, setData] = useState(null);
  // const [responseData, setResponseData] = useState({});
  const [clusters, setClusters] = useState(null);
  const [shownInstitution, setShownInstitution] = useState(null);
  const [shownTestGroups, setShownTestGroups] = useState(null);
  const [selectedTestGroup, setSelectedTestGroup] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);

  const labels = {
    expired: "Abgelaufen",
    in_progress: "In Bearbeitung",
    used_sek1: "Verbraucht Sek I",
    used_sek2: "Verbraucht Sek II",
    active: "Aktiv",
    sek1: "Sek I",
    sek2: "Sek II"
  };

  // const checkForMissingInstitution = useCallback(
  //   instarray => {
  //     // NOTE: KC21K-575: Check if it's a testing client
  //     // and there are no testgroups of own inst.
  //
  //     if (appState.user.institution !== null) return false;
  //     let instID = appState.user.client.selfassignedInstitution._id;
  //     if (instID !== instarray[0]._id) return true;
  //     return false;
  //   },
  //   [appState]
  // );

  const isInstitutionAdmin = useCallback(() => {
    return (appState.user.institution !== null);
  }, [appState])

  const loadData = useCallback(() => {
    DataFetcher.fetch("/licence/cluster")
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/");
        }
        // setResponseData(response);
        let filteredClients = Object.keys(response.clusters)
          .filter(item => response.clusters[item].hasOwnProperty("_id"))
          .map(item => {
            return response.clusters[item];
          });
        let instObj = filteredClients[0].institutions;
        let filteredInstitutions = Object.keys(instObj).map(key => {
          let inst = instObj[key];
          return Boolean(inst._id) ? inst : null;
        });

        // Check if testing client and if its own institution is in filteredInstitutions
        // and if so check if own institution is at index 0
        if (!isInstitutionAdmin()) {
          filteredInstitutions = filteredInstitutions.filter(inst => inst._id === appState.user.client.selfassignedInstitution._id);
        }

        // if (checkForMissingInstitution(filteredInstitutions)) return setClusters([]);
        if (!Boolean(filteredInstitutions.length)) return setClusters([]);

        let instIndex = appState.user.type === "super-admin" ? 1 : 0;
        setShownInstitution(filteredInstitutions[instIndex]);
        let tgObj = filteredInstitutions[instIndex].testgroups;
        let testgroups = Object.keys(tgObj).map(i => {
          let item = { ...tgObj[i] };
          item.visible = true;
          return item;
        });
        setShownTestGroups(testgroups);

        return setClusters(filteredClients);
      })
      .catch(error => {
        console.error(error);
        return history.push("/");
      });
  }, [appDispatch, appState, isInstitutionAdmin, history]);

  useEffect(() => {
    if (!clusters) {
      loadData();
    }
  }, [clusters, loadData]);
  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  const onPDFClick = url => {
    DataFetcher.fetch(url, {}, "")
      .then(response => {
        if (!response.success) console.log("Error", JSON.stringify(response));
        return console.log("Success");
      })
      .catch(error => {
        console.error(error);
      });
  };

  const getNames = rna => {
    if (!rna.hasOwnProperty("lastname") && !rna.hasOwnProperty("firstname")) return "---";
    return `${rna.lastname}, ${rna.firstname}`;
  };

  const renderTable = (array, id, noPdfsVisible) => {
    let used = array.filter(item => item.status.indexOf("used") === 0).sort(sortBy("lastname"));
    let expired = array.filter(item => item.status === "expired");
    let progress = array.filter(item => item.status === "in_progress");
    let active = array.filter(item => item.status === "active");

    let sorted = [...used, ...progress, ...active, ...expired];

    // let rows = array.map((row, index) => {
    let rows = sorted.map((row, index) => {
      return row.visible ? (
        <tr key={`${id}-${index}`}>
          {/* <td>{moment(item.ts).format("DD.MM.YYYY")}</td> */}
          <td>{row.key}</td>
          <td>{getNames(row)}</td>
          <td>{Object.keys(labels).includes(row.status) ? <StateLights label={row.status} /> : row.status}</td>
          {!noPdfsVisible && (
            <td>
              {Boolean(row.pdf) ? (
                <button
                  className="button"
                  onClick={e => {
                    onPDFClick(row.pdf);
                  }}>
                  PDF
                </button>
              ) : (
                "---"
              )}
            </td>
          )}
        </tr>
      ) : null;
    });
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Lizenzschlüssel</th>
            <th>Name, Vorname</th>
            <th>Status</th>
            {!noPdfsVisible && <th>PDF</th>}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  };

  const tabFilterOps = [
    { type: "text", key: "lastname", label: "Nachname" },
    {
      type: "select",
      key: "status",
      label: "Status",
      options: [
        { value: "active", label: "Noch nicht begonnen" },
        { value: "in_progress", label: "Bereits begonnen" },
        { value: "used", label: "Abgeschlossen" },
        { value: "expired", label: "Abgelaufen" }
      ]
    }
  ];
  const onTabFilter = filtered => setSelectedTable(filtered);

  const TestGroup = props => {
    let obj = props.data;
    return (
      <div className="content">
        <div className="testgroup">
          <p>
            <strong>Datum:</strong> {obj.orderDate}
          </p>
          <FilterBar source={selectedTable} filterOptions={tabFilterOps} onFilter={onTabFilter} />
          {renderTable(selectedTable, obj.name, obj.noPdfsVisible)}
          <button className="button" onClick={onTGBack}>
            zurück
          </button>
        </div>
      </div>
    );
  };

  const onTestGroupSelect = obj => {
    let array = obj.licences.map(item => {
      return { ...item, visible: true };
    });
    setSelectedTable(array);
    return setSelectedTestGroup(obj);
  };
  const onTGBack = () => {
    setSelectedTable(null);
    return setSelectedTestGroup(null);
  };

  const renderGroup = (obj, key) => {
    return (
      <div className="card tg" key={key}>
        {/* <header className="card-header">
          <h4 className="card-header-title">{obj.name}</h4>
        </header> */}
        <div className="card-content">
          <h4 className="title">{obj.name}</h4>
          <p>
            <strong>Datum:</strong> {obj.orderDate}
            <br />
            <strong>Anzahl Lizenzen:</strong> {obj.count}
            <br />
            {Boolean(obj.targetgroup) && (
              <>
                <strong>Zielgruppe:</strong> {labels[obj.targetgroup]}
              </>
            )}
          </p>
          <button
            className="button is-fullwidth"
            onClick={e => {
              onPDFClick(obj.pdf);
            }}>
            Lizenschlüssel-PDF
          </button>
        </div>
        <footer className="card-footer">
          <button
            className="card-footer-item"
            onClick={e => {
              onTestGroupSelect(obj);
              // setSelectedTestGroup(obj);
            }}>
            Details
          </button>
        </footer>
      </div>
    );
  };

  const filterOps = [
    { type: "text", key: "name", label: "Gruppe/Klasse" },
    { type: "date", key: "orderDate", label: "Datum", isSimple: true },
    {
      type: "select",
      key: "targetgroup",
      label: "Zielgruppe",
      options: [
        { value: "sek1", label: "Sek I" },
        { value: "sek2", label: "Sek II" }
      ]
    }
  ];
  const onFilter = filtered => setShownTestGroups(filtered);

  const renderTestGroups = () => {
    let groups = shownTestGroups
      .sort(sortBy("orderDate", "desc", "date"))
      .filter(item => item.visible)
      .map((group, index) => {
        return renderGroup(group, `group-${group.name}-${index}`);
      });
    return (
      <>
        <FilterBar source={shownTestGroups} filterOptions={filterOps} onFilter={onFilter} />
        {Boolean(groups.length) ? <div className="tgs">{groups}</div> : <NoResults msg="Keine Ergebnisse" />}
      </>
    );
  };

  const renderInstitution = () => {
    return (
      <div className="institutions">
        <div className="institution">
          <h2 className="title is-5 no-mb">Institution: {shownInstitution.name}</h2>
          {/* {shownInstitution.interestGroup !== "self" && (
            <p className="interestgroup">
              <strong>Interessengruppe:</strong> {getInterestGroup(shownInstitution.interestGroup)}
            </p>
          )} */}
          <div className="content">{renderTestGroups(shownInstitution.testgroups)}</div>
        </div>
      </div>
    );
  };
  const renderClients = () => {
    let clientDivs = clusters.map((cl, index) => {
      return (
        <div className="client" key={`client-${index}`}>
          {/* <span className="tag is-light">{cl.name}</span> */}
          {/* {renderInstitutions(cl.institutions)} */}
          {renderInstitution()}
        </div>
      );
    });
    return Boolean(clientDivs.length) ? <div className="clients">{clientDivs[0]}</div> : <p className="alert">Es wurden noch keine Testgruppen angelegt.</p>;
  };

  return (
    <main className="licences">
      <h1 className="title">{selectedTestGroup ? `Details: ${selectedTestGroup.name}` : "Übersicht"}</h1>
      {!clusters && !selectedTestGroup && <LoadingIndicator />}
      {clusters && !selectedTestGroup && renderClients()}
      {selectedTestGroup && <TestGroup data={selectedTestGroup} />}
    </main>
  );
}
export default ListLicences;
